var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBulb = function SvgBulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 17",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5E6B78",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2 8.72h.667M8 2.72v.667m5.333 5.334H14M3.733 4.454l.467.467m8.067-.467l-.467.467"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.387a3.333 3.333 0 114 0 2.333 2.333 0 00-.667 2 1.333 1.333 0 01-2.666 0 2.334 2.334 0 00-.667-2m.467.667h3.066",
    stroke: "#48525C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBulb;